import {
  getDate,
  getTimestampInMillisecondsFromSecond
} from "@/helpers/date.helpers"

import type { Statistic, StatisticsResponse } from "@/api/useStatistics.types"

export const getTimestampPosture = (data: Statistic) =>
  getTimestampInMillisecondsFromSecond(data.timestamp)

export const statisticsSelector = (response: StatisticsResponse) => {
  const data = response?.data || []
  const day = getDate()

  const { value = 0 } = data[0] || {}
  const weekAgoIndex = data
    .slice(0, 8)
    .findIndex(
      (posture) => day.diff(getTimestampPosture(posture), "days") === 7
    )

  return {
    weekAgoIndex,
    data,
    score: value || 0
  }
}
